var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg167WallClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.02,74.98C388.667,26.629,324.38,0,256,0S123.333,26.629,74.98,74.98C26.629,123.333,0,187.62,0,256 s26.629,132.667,74.98,181.02C123.333,485.371,187.62,512,256,512c46.813,0,92.617-12.757,132.461-36.893 c9.448-5.723,12.468-18.021,6.745-27.468c-5.722-9.449-18.022-12.468-27.468-6.745C334.143,461.244,295.505,472,256,472 c-119.103,0-216-96.897-216-216S136.897,40,256,40s216,96.897,216,216c0,42.589-12.665,84.044-36.627,119.885 c-6.139,9.182-3.672,21.603,5.511,27.742c9.183,6.139,21.603,3.671,27.742-5.511C497.001,355.674,512,306.531,512,256 C512,187.62,485.371,123.333,437.02,74.98z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,76c-11.046,0-20,8.954-20,20v151.716l-73.338,73.338c-7.811,7.81-7.811,20.473,0,28.284 c3.905,3.905,9.023,5.858,14.142,5.858s10.237-1.953,14.142-5.858l79.196-79.196c3.751-3.75,5.858-8.838,5.858-14.142V96 C276,84.954,267.046,76,256,76z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg167WallClock);
export default __webpack_public_path__ + "static/media/167-wall-clock.76b06c93bf975eac017f0016a4ab096f.svg";
export { ForwardRef as ReactComponent };